import { createSlice } from "@reduxjs/toolkit";

export const pageSlice = createSlice({
  name: 'page',
  initialState: {
    currentPage: '',
    previousPage: '',
    isLoading: true,
    tableLoading: false,
    minimizeSidebar: true,
    confirmLeavePage: false,
    grologAccInfo:{},
    isAddOrEditPage: false,
    catchError: '',
    path: '',
    confirmationDelete: false,
    statusInvitation:false,
    isCompletion:false,
    pagePersonTitle:1,
    limitPersonTitle:10,
    pageCountry:1,
    limitCountry:10,
    pageIsland:1,
    limitIsland:10,
    pageProvince:1,
    limitProvince:10,
    pageDistrict:1,
    limitDistrict:10,
    pageSubDistrict:1,
    limitSubDistrict:10,
    pageUrbanVillage:1,
    limitUrbanVillage:10,
    pagePostalCode:1,
    limitPostalCode:10,
  },
  reducers:{
    setPage: (state, action) => {
      state.currentPage = action.payload
      state.previousPage = action.payload
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setTableLoading: (state, action) => {
      state.tableLoading = action.payload
    },
    setCatchError: (state, action) => {
      state.catchError = action.payload
    },
    setMinimizeSidebar: (state, action) => {
      state.minimizeSidebar = action.payload
    },
    setConfirmLeavePage: (state, action) => {
      state.confirmLeavePage = action.payload
    },
    setIsAddOrEditPage: (state, action) => {
      state.isAddOrEditPage = action.payload
    },
    setPath: (state, action) => {
      state.path = action.payload
    },
    clearPage: (state) => {
      state.currentPage = ''
      state.previousPage = ''
    },
    clearCatchError: (state) => {
      state.catchError = ''
    },
    defaultIsLoading: (state) => {
      state.isLoading = false
    },
    setConfirmationDelete: (state, action) => {
      state.confirmationDelete = action.payload
    },
    setGrologAccInfo:(state,action)=>{
      state.grologAccInfo = action.payload
    },
    setStatusInvitation:(state,action)=>{
      state.statusInvitation = action.payload
    },
    setIsCompletion:(state,action)=>{
      state.isCompletion = action.payload
    },
    setPageCountry:(state,action)=>{
      state.pageCountry = action.payload
      state.limitCountry = action.payload
    },
    setPageProvince:(state,action)=>{
      state.pageProvince = action.payload
      state.limitProvince = action.payload
    },
  }
})

export const {
  setPage,
  setIsLoading,
  setCatchError,
  clearPage,
  clearCatchError,
  defaultIsLoading,
  setMinimizeSidebar,
  setTableLoading,
  setConfirmLeavePage,
  setIsAddOrEditPage,
  setPath,
  setConfirmationDelete,
  setGrologAccInfo,
  setStatusInvitation,
  setIsCompletion,
  setPageCountry,
  setPageProvince
} = pageSlice.actions

export default pageSlice.reducer